export const CATS_ABANDONED_CART_INTERNAL_ROOT_PATH = "/abandoned-cart/internal";

export const CATS_ABANDONED_CART_INTERNAL_FRESH_SUFFIX = "/fresh";
/** /abandoned-cart/internal/fresh */
export const CATS_ABANDONED_CART_INTERNAL_FRESH_PATH =
  CATS_ABANDONED_CART_INTERNAL_ROOT_PATH + CATS_ABANDONED_CART_INTERNAL_FRESH_SUFFIX;

export const CATS_ABANDONED_CART_INTERNAL_SCOOP_SUFFIX = "/scoop";
/** /abandoned-cart/internal/scoop */
export const CATS_ABANDONED_CART_INTERNAL_SCOOP_PATH =
  CATS_ABANDONED_CART_INTERNAL_ROOT_PATH + CATS_ABANDONED_CART_INTERNAL_SCOOP_SUFFIX;

export const CATS_ABANDONED_CART_CUSTOMER_ROOT_PATH = "/abandoned-cart/customer";
export const CATS_ABANDONED_CART_CUSTOMER_FRESH_SUFFIX = "/fresh";
/** /abandoned-cart/customer/fresh */
export const CATS_ABANDONED_CART_CUSTOMER_FRESH_PATH = `${
  CATS_ABANDONED_CART_CUSTOMER_ROOT_PATH
}${
  CATS_ABANDONED_CART_CUSTOMER_FRESH_SUFFIX
}`;

export const CATS_ABANDONED_CART_BREEDER_ROOT_PATH = "/abandoned-cart/breeder";
export const CATS_ABANDONED_CART_BREEDER_FRESH_SUFFIX = "/fresh";
/** /abandoned-cart/breeder/fresh */
export const CATS_ABANDONED_CART_BREEDER_FRESH_PATH = `${
  CATS_ABANDONED_CART_BREEDER_ROOT_PATH
}${
  CATS_ABANDONED_CART_BREEDER_FRESH_SUFFIX
}`;

export const CATS_ABANDONED_CART_PUBLIC_ROOT_PATH = "/abandoned-cart";
export const CATS_ABANDONED_CART_PUBLIC_FRESH_SUFFIX = "/fresh";
/** /abandoned-cart/fresh */
export const CATS_ABANDONED_CART_PUBLIC_FRESH_PATH = `${
  CATS_ABANDONED_CART_PUBLIC_ROOT_PATH
}${
  CATS_ABANDONED_CART_PUBLIC_FRESH_SUFFIX
}`;
